<template>
    <el-container>
        <el-main>
            <el-dialog :title="categoryTitle" :visible.sync="showCategory" width="35%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="formData" :model="formData" label-width="100px" :rules="rules" class="demo-ruleForm">                
                    <el-form-item label="分类名称：" prop="categoryName">
                        <el-input v-model="formData.categoryName"  placeholder="分类名称"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="saveCategory('formData')">确 定</el-button>
                </div>
            </el-dialog>
            <el-select v-if="orgType == 1" placeholder="" size="small" placeholder="机构" v-model="orgCode" @change="changeOrg" style="margin-right: 10px;">
              <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
            </el-select>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addCategory" class="but-cls">添加消息分类</el-button>
            <el-table
                    :data="treeData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="categoryId"
                    border
                    ref="tableData"
                    :loading = "loading"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
               <!-- <el-table-column              
                        label="分类图标"
                        width="200"                     
                >
                   <template slot-scope="scope">               
                       <div v-html="generatorIcon(scope.$index, scope.row)"></div>
                   </template>
                </el-table-column> -->
                <el-table-column
                        prop="categoryName"
                        label="消息分类名称"
                >
                </el-table-column>
              
                <el-table-column
                  
                        label="操作"
                        width="250"
                >
                    <template slot-scope="scope">
                        <!-- <template v-if="scope.row.level == 1">
                            <el-button @click="addCategory(scope.$index, scope.row)"  size="small" type="text">添加</el-button>
                        </template> -->
                        <el-button @click="updateCategory(scope.$index, scope.row)" type="text"  size="small">修改</el-button>
                        <el-button @click="deleteCategory(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
                        <el-button @click="upCategory(scope.$index, scope.row)" type="text"  size="small">上移</el-button>
                        <el-button @click="downCategory(scope.$index, scope.row)" type="text"  size="small">下移</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    
    export default {
        data() {           
            const data = [];

            return {
                org: [],
                orgCode: '',
                orgType: '',
                showTree: true,
                treeData: [],
                top: false,
                showCategory:false,
                loading: false,
                categoryTitle: "添加消息分类",
                formData: {
                  categoryId: "",
                  categoryName: "",
                  orgCode: ""
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    categoryName: [
                        { required: true, message: '请填写分类名称', trigger: 'blur' },
                        {  max: 50, message: '长度不得超过 50 个字符', trigger: 'blur' }
                    ],
                    imageUrl:{ max: 100, message: '长度不得超过 100 个字符', trigger: 'blur'}
                },
            }
        },
        methods: {
            handleDialogClose() {
                this.showCategory = false;
                this.$refs.formData.resetFields();
            },
            search() {
                this.loading = true;
                let params = {
                  orgCode: this.orgCode
                };
                https.fetchPost('/webMessageCategory/list',params, "json" ).then((data) => {
                    let code = data.data.code;
                    if(code == 200) {
                        this.loading = false;
                        this.treeData = data.data.data
                    } else {
                        this.loading = false;
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }

                }).catch(err=>{
                    this.$message.error('网络错误');
                    this.loading = false;
                    }
                )              
            },
             addCategory(index, row) {
                this.showCategory = true;
               this.formData = {};
                this.categoryTitle = "添加消息分类";
            },
            updateCategory(index, row) {
                this.categoryTitle = "修改消息分类";
                this.showCategory = true;
                this.formData = JSON.parse(JSON.stringify(row));
            },
            saveCategory(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        this.formData.orgCode = this.orgCode;
                        let params = this.formData;
                        let url = "/webMessageCategory/addCategory";
                        console.log(this.formData);
                        if(this.formData.categoryId) {
                            url = "/webMessageCategory/updateCategory";
                        }
                        https.fetchPost(url,params ,"json").then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.showCategory = false;
                                this.search();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                                console.log(err);
                                this.$message.error('网络错误');
                            }
                        )
                    }
                });
            },
            deleteCategory(index, row){
                this.$confirm('此操作将删除此分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let _row = JSON.parse(JSON.stringify(row));
                    let categoryIdList=[];
                    categoryIdList.push(_row.categoryId);

                    var params={"categoryIdList":categoryIdList};
                        https.fetchPost("/webMessageCategory/deleteCategory",params ,"json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.search();
                        } else {
                            this.$message.error('操作失败:'+msg);
                        }

                    }).catch(err=>{
                            console.log(err);
                            this.$message.error('网络错误');
                        }
                    )
                });                 
            },
            upCategory(index, row){
                let params = row;
                https.fetchPost("/webMessageCategory/updateUpSort",params ,"json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.search();
                    } else {
                        this.$message.info('操作失败:'+msg);
                    }

                }).catch(err=>{
                        console.log(err);
                        this.$message.error('网络错误');
                    }
                )
            },
            downCategory(index, row){
                let params = row;
                https.fetchPost("/webMessageCategory/updateDownSort",params ,"json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.search();
                    } else {
                        this.$message.info('操作失败:'+msg);
                    }

                }).catch(err=>{
                        console.log(err);
                        this.$message.error('网络错误');
                    }
                )
            },
            generatorIcon(index,row){
                 let params = row;
                 var html ="<span class=\"icon iconfont "+row.imageUrl+"\"></span>"+"<span style='margin-left:10px;'>"+row.imageUrl+"</span>";
                 return html;
            },
          selectOrg() {
            https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
                if(this.org.length > 0) {
                  this.orgCode = this.org[0].orgCode;
                }
                this.search(this.orgCode);
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          },
          changeOrg(val) {
            this.orgCode = val;
            this.search(val);
          },
        },
        created: function () {
            this.orgType = this.$store.state.orgType;
            this.selectOrg();
        }
    }
</script>

<style scoped>
@import "//at.alicdn.com/t/font_1200137_ei4wc2os8jv.css";
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
</style>